/**
 * Datos de ejemplo para cargar automáticamente
 */

export const exampleCitas = [
  {
    "id": "1",
    "nombre": "Shabat",
    "tipo": "religiosa",
    "descripcion": "Día de descanso semanal",
    "cita": "Éxodo 20:8-11",
    "color": "#4A90E2",
    "icono": "star",
    "duracion": 1440,
    "fechaInicio": "2025-11-07T18:00:00",
    "fechaFin": "2025-11-08T18:00:00"
  },
  {
    "id": "2",
    "nombre": "Oración Matutina",
    "tipo": "oración",
    "descripcion": "Shajarit - Oración de la mañana",
    "cita": "Salmos 5:3",
    "color": "#E24A90",
    "icono": "prayer",
    "duracion": 30,
    "fechaInicio": "2025-11-08T07:00:00",
    "fechaFin": "2025-11-08T07:30:00"
  }
];

export const exampleLecturas = [
  {
    "id": "1",
    "tipo": "Torah",
    "subtipo": "Parasha",
    "descripcion": "Lectura semanal de la Torah",
    "referencia": "Génesis 1:1-6:8 - Bereshit",
    "color": "#90E24A",
    "icono": "torah",
    "fecha": "2025-11-08"
  },
  {
    "id": "2",
    "tipo": "Salmos",
    "subtipo": "Diario",
    "descripcion": "Salmo del día",
    "referencia": "Salmo 145",
    "color": "#4AC4E2",
    "icono": "book",
    "fecha": "2025-11-08"
  },
  {
    "id": "3",
    "tipo": "Profetas",
    "subtipo": "Haftarah",
    "descripcion": "Lectura de los profetas",
    "referencia": "Isaías 42:5-43:10",
    "color": "#E2C44A",
    "icono": "book",
    "fecha": "2025-11-08"
  }
];

export const exampleEventos = [
  {
    "id": "1",
    "nombre": "Rosh Hashaná",
    "descripcion": "Año Nuevo Judío - Celebración del inicio del año 5786",
    "tipo": "festividad",
    "subtipo": "mayor",
    "palabrasClave": ["año nuevo", "shofar", "manzanas", "miel"],
    "categoria": "religiosa",
    "fechaInicio": "2025-09-23T18:00:00",
    "fechaFin": "2025-09-25T18:00:00",
    "duracion": 2880,
    "color": "#E24A90",
    "icono": "shofar"
  },
  {
    "id": "2",
    "nombre": "Yom Kippur",
    "descripcion": "Día de la Expiación - Día más sagrado del año judío",
    "tipo": "festividad",
    "subtipo": "mayor",
    "palabrasClave": ["ayuno", "expiación", "perdón", "teshuva"],
    "categoria": "religiosa",
    "fechaInicio": "2025-10-02T18:00:00",
    "fechaFin": "2025-10-03T18:00:00",
    "duracion": 1440,
    "color": "#4A90E2",
    "icono": "prayer"
  },
  {
    "id": "3",
    "nombre": "Sucot",
    "descripcion": "Fiesta de los Tabernáculos - Celebración de la cosecha",
    "tipo": "festividad",
    "subtipo": "peregrinación",
    "palabrasClave": ["sucá", "lulav", "etrog", "cosecha"],
    "categoria": "religiosa",
    "fechaInicio": "2025-10-07T18:00:00",
    "fechaFin": "2025-10-14T18:00:00",
    "duracion": 10080,
    "color": "#90E24A",
    "icono": "celebration"
  },
  {
    "id": "4",
    "nombre": "Janucá",
    "descripcion": "Festival de las Luces - Celebración del milagro del aceite",
    "tipo": "festividad",
    "subtipo": "menor",
    "palabrasClave": ["menorá", "aceite", "milagro", "luces"],
    "categoria": "religiosa",
    "fechaInicio": "2025-12-15T18:00:00",
    "fechaFin": "2025-12-23T18:00:00",
    "duracion": 11520,
    "color": "#4AC4E2",
    "icono": "menorah"
  },
  {
    "id": "5",
    "nombre": "Purim",
    "descripcion": "Celebración de la salvación del pueblo judío en Persia",
    "tipo": "festividad",
    "subtipo": "menor",
    "palabrasClave": ["Ester", "Hamán", "salvación", "alegría"],
    "categoria": "religiosa",
    "fechaInicio": "2026-03-03T18:00:00",
    "fechaFin": "2026-03-04T18:00:00",
    "duracion": 1440,
    "color": "#E2C44A",
    "icono": "celebration"
  },
  {
    "id": "6",
    "nombre": "Pesaj",
    "descripcion": "Pascua Judía - Celebración del éxodo de Egipto",
    "tipo": "festividad",
    "subtipo": "peregrinación",
    "palabrasClave": ["séder", "matzá", "éxodo", "libertad"],
    "categoria": "religiosa",
    "fechaInicio": "2026-04-01T18:00:00",
    "fechaFin": "2026-04-08T18:00:00",
    "duracion": 10080,
    "color": "#4A90E2",
    "icono": "celebration"
  }
];

/**
 * Carga los datos de ejemplo si el localStorage está vacío
 */
export function loadExamplesIfEmpty() {
  const hasData = localStorage.getItem('citas') || 
                  localStorage.getItem('lecturas') || 
                  localStorage.getItem('eventos');
  
  if (!hasData) {
    console.log('📚 Cargando datos de ejemplo...');
    localStorage.setItem('citas', JSON.stringify(exampleCitas));
    localStorage.setItem('lecturas', JSON.stringify(exampleLecturas));
    localStorage.setItem('eventos', JSON.stringify(exampleEventos));
    console.log('✅ Datos de ejemplo cargados');
    return true;
  }
  
  return false;
}













